var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManufacturer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1446_12665)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5 4.5V31.5H3V21.471L7.3552 14.2189L10.6519 19.7152L13.9486 14.2189L17.25 19.7152L20.5467 14.2189L23.8481 19.7152V4.5H31.5Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1446_12665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.5,
    height: 27,
    fill: "white",
    transform: "translate(3 4.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManufacturer);
export default __webpack_public_path__ + "static/media/manufacturer.f2a9460b6388c450e0ed50e03ac8ccab.svg";
export { ForwardRef as ReactComponent };